import axios from '@/plugins/axios'
import fileDownload from 'js-file-download'

export const listWebhookEvents = (_, { params } = {}) => {
  return axios.get('webhook-events', { params })
    .then(response => response.data)
}

export const exportWebhookEvents = (_, { params } = {}) => {
  return axios.get('webhook-events/export', { params, responseType: 'blob' })
    .then(response => {
      const disposition = response.headers['content-disposition'] || ''
      const filename = (disposition.split('filename=')[1] || 'webhook-events.xlsx').replace(/"/g, '')
      fileDownload(response.data, filename)
      return response
    })
}
